import type { SVGProps } from 'react';
const SvgDeveloperBoard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#developer_board_svg__a)">
      <path
        fill="currentColor"
        d="M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2Zm-4 10H4V5h14v14ZM6 13h5v4H6v-4Zm6-6h4v3h-4V7ZM6 7h5v5H6V7Zm6 4h4v6h-4v-6Z"
      />
    </g>
    <defs>
      <clipPath id="developer_board_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDeveloperBoard;
